import moment from 'moment';
import { Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../../app/hooks';
import Spinner from '../../../components/common/Spinner';
import { formatUSD, USDT } from '../../../helpers/helperFunctions';
import { Button } from '../../../styles/GlobalComponents';
import { FlexBetween } from '../../../styles/stylesStyled';
import { EarningDetailsComponent, Txt4 } from './EarningsHistoryStyled';

const getStatusName = (status: number | undefined) => {
  switch (status) {
    case 1:
      return 'Pending';
    case 2:
      return 'Paid';
    default:
      return '';
  }
};

export const EarningDetails = ({
  setIsEarningsDetailsOpened
}: {
  setIsEarningsDetailsOpened: Dispatch<SetStateAction<boolean>>;
}) => {
  const { t } = useTranslation('earnings');

  const { loadingHistory, earningDetails } = useAppSelector(
    (state) => state.earnings
  );

  return (
    <EarningDetailsComponent>
      {loadingHistory ? (
        <Spinner />
      ) : (
        <>
          {' '}
          <FlexBetween>
            <Txt4>{t('status')}</Txt4>{' '}
            <Txt4 weight>{getStatusName(earningDetails?.status)}</Txt4>
          </FlexBetween>
          {earningDetails?.orderId && (
            <FlexBetween>
              <Txt4>{t('order_id')}</Txt4>{' '}
              <Txt4 weight>{earningDetails?.orderId}</Txt4>
            </FlexBetween>
          )}
          {earningDetails?.orderDateCreated ? (
            <FlexBetween>
              <Txt4>{t('order_date')}</Txt4>{' '}
              <Txt4 weight>
                {' '}
                {moment(earningDetails?.orderDateCreated).format('DD.MM.YYYY')}
              </Txt4>
            </FlexBetween>
          ) : (
            <FlexBetween>
              <Txt4>Bonus date </Txt4>{' '}
              <Txt4 weight>
                {' '}
                {moment(earningDetails?.bonusDateCreated).format('DD.MM.YYYY')}
              </Txt4>
            </FlexBetween>
          )}
          {earningDetails?.user && (
            <FlexBetween>
              <Txt4>{t('user_id')}</Txt4>{' '}
              <Txt4 weight>
                {earningDetails?.user &&
                  `${earningDetails?.user?.name} ${
                    earningDetails?.user?.surname?.length > 0 &&
                    earningDetails?.user?.surname[0]?.toUpperCase()
                  }. (#${earningDetails?.user?.id})`}
              </Txt4>
            </FlexBetween>
          )}
          {earningDetails?.orderAmount && (
            <FlexBetween>
              <Txt4>{t('order_volume')}</Txt4>{' '}
              <Txt4 weight>
                {formatUSD(earningDetails?.orderAmount)} {USDT}
              </Txt4>
            </FlexBetween>
          )}
          <FlexBetween>
            <Txt4>{t('reward_type')}</Txt4>{' '}
            <Txt4 weight>{earningDetails?.name}</Txt4>
          </FlexBetween>
          <FlexBetween>
            <Txt4>{t('reward_amount')}</Txt4>{' '}
            <Txt4 weight>
              {formatUSD(earningDetails?.amount)} {USDT}
            </Txt4>
          </FlexBetween>
          {earningDetails?.datePaid && (
            <FlexBetween>
              <Txt4>{t('payment_date')}</Txt4>{' '}
              <Txt4 weight>
                {' '}
                {moment(earningDetails?.datePaid).format('DD.MM.YYYY')}
              </Txt4>
            </FlexBetween>
          )}
          <Button
            mt='40'
            negative
            onClick={() => setIsEarningsDetailsOpened(false)}>
            Close
          </Button>
        </>
      )}
    </EarningDetailsComponent>
  );
};
